<div style="display: inline-block">
  <div class="chip-custom" [ngClass]="[size, backgroundColor]">
    <ng-content></ng-content>
    @if (removable) {
      <mat-icon (click)="removed.emit()" class="remove-icon">cancel</mat-icon>
    }
  </div>
</div>
